module.exports = __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Light.de87dfe9.woff2";